import React, { useState } from "react";
const Navbar = ()=>{
    return(
        <nav className="navbar navbar-expand-md px-5">
            <a className="navbar-brand" href="/">
              <img src="/mangalLogo.png" style={{height: 40}}/>
            </a>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav ms-auto">
                <li className="nav-item px-2">
                  <a className="nav-link" href="/">Home</a>
                </li>

                <li className="nav-item px-2">
                  <a className="nav-link" href="/form">Form</a>
                </li>

                <li className="nav-item px-2">
                  <a className="nav-link" href="#">FAQs</a>
                </li>

                <li className="nav-item px-2">
                  <a className="nav-link" href="/contact">Contact</a>
                </li>
              </ul>
            </div>
        </nav>
    )
}

export default Navbar;
